import React from "react";
import { Typography, Paper, IconButton, Tooltip, Stack, Accordion, AccordionSummary, AccordionDetails, AccordionActions, Divider, Checkbox, InputLabel, MenuItem, FormControl, FormControlLabel, Select, DialogTitle, DialogContent, DialogActions, TextField, Button, List, ListItem, ListItemText, ListSubheader, ListItemSecondaryAction} from "@mui/material";
import { D, HardConfirmDialog, C} from "../include";
import { Visibility, Edit, Delete, CheckCircle, RemoveCircle, Cancel, PermContactCalendar, CreateNewFolder, FolderOff, FolderOpen, HealthAndSafety, Architecture, Share, AppRegistration } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import DrawIcon from '@mui/icons-material/Draw';
import { ViewPatient } from "./Patient"
import { Session, NewSessionDialog } from "./Session"
import { Survey } from "./Survey"
import { SignatureDialog } from "./Signature"


function computeAge(birthday){
    var age = 18;
    if(birthday){
      //Converte DD/MM/YYYY em um Date object
      let [day, month, year] = birthday.split('/')
      const birthdayObj = new Date(+year, +month - 1, +day)
      
      var diff_ms = Date.now() - birthdayObj; //difference in milliseconds
      var age_dt = new Date(diff_ms); 
      age = Math.abs(age_dt.getUTCFullYear() - 1970); //difference in years between the age Date object and the year 1970 (UNIX epoch)
    }    
    return age;
}


class EditProcedure extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      procedure_id: this.props.procedure_id ? this.props.procedure_id : -1,
      patient_id: this.props.patient_id ? this.props.patient_id : -1,
      company_id: this.props.company_id ? this.props.company_id : -1,
      treatment_id: this.props.row ? this.props.row.treatment_id : '',
      patient_age: this.props.patient_age ? this.props.patient_age : 18,
      finished: this.props.row ? this.props.row.finished : null,
      training_patient: this.props.row ? this.props.row.training_patient : false,
      allowed_to_post: this.props.row ? this.props.row.allowed_to_post : 1,
      allowed_to_post_complement: this.props.row ? this.props.row.allowed_to_post_complement : '',
      price: this.props.row ? this.props.row.price : 'R$ ',
      treatment_list: {},
    };
  }
  
  componentDidMount() {
    this.setState({ loading: true });
    this.props.api
      .get('/TreatmentsBrief')
      .then((r) => {
        var list = {}
        for(var row in r.treatments){
          list[ r.treatments[row]["id"] ]= r.treatments[row]["name"];          
        }
        this.setState({
          treatment_list: list,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }





  handleSubmit = () => {
    if (!this.props.edit) {
      this.props.api
        .post('/Procedures/', { patient_id: this.state.patient_id, treatment_id: this.state.treatment_id, company_id: this.state.company_id, patient_age: this.state.patient_age, finished: this.state.finished, training_patient: this.state.training_patient, allowed_to_post: this.state.allowed_to_post, allowed_to_post_complement: this.state.allowed_to_post_complement, price: this.state.price })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Procedimento criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Procedure/' + this.state.procedure_id, { patient_id: this.state.patient_id, treatment_id: this.state.treatment_id, company_id: this.state.company_id, patient_age: this.state.patient_age, finished: this.state.finished, training_patient: this.state.training_patient, allowed_to_post: this.state.allowed_to_post, allowed_to_post_complement: this.state.allowed_to_post_complement, price: this.state.price })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit} method="GET">
        <input type="hidden" name="r" value={this.state.patient_id} /> 
        
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Procedimento' : 'Adicionar Procedimento'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          <FormControl style={{paddingTop: '0.5rem'}} fullWidth>
            <InputLabel id="select-type">Tratamento</InputLabel>
            <Select
              labelId="select-treatment"
              id="select-t"
              value={Object.keys(this.state.treatment_list).length ? this.state.treatment_id : ''}
              label="Tratamento"
              onChange={(e) => this.setState({treatment_id: e.target.value})}
            >
              {Object.keys(this.state.treatment_list).map(key => {
                  return <MenuItem key={key} value={key}>{this.state.treatment_list[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />
          
          <FormControlLabel control={
            <Checkbox 
              checked={this.state.training_patient} 
              onChange={(e) => this.setState({ training_patient: e.target.checked })} 
            />
          } label="É paciente-modelo" />
          <D h="1 rem" />

          {this.props.edit && 
            <FormControlLabel 
              control={
                <Checkbox 
                  checked={this.state.finished ? true : false} 
                  onChange={(e) => this.setState({ finished: e.target.checked ? new Date(Date.now()).toISOString() : null } )} 
                />
              }
              label="Procedimento foi finalizado" 
            />
          }
                         
          <FormControl style={{paddingTop: '0.5rem', marginTop: '1rem'}} fullWidth>
            <InputLabel id="select-allow">Consentimento para Publicação</InputLabel>
            <Select
              labelId="select-type"
              id="select-t"
              value={this.state.allowed_to_post}
              label="Consentimento para Publicação"
              onChange={(e) => this.setState({allowed_to_post: e.target.value, allowed_to_post_complement: e.target.value!==2 ? "" : this.state.allowed_to_post_complement})}
            >
              {Object.keys(C.AllowedToPostType).map(key => {
                  return <MenuItem key={key} value={key}>{C.AllowedToPostType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>       
          { parseInt(this.state.allowed_to_post)===2 && (
            <>
              <D h="1rem" />
              <TextField
                fullWidth
                variant="outlined"
                label="Consentimento - Detalhe"
                value={this.state.allowed_to_post_complement}
                onChange={(e) => this.setState({ allowed_to_post_complement: e.target.value })}
              />
            </>
          )}
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Valor Cobrado"
            value={this.state.price}
            onChange={(e) => this.setState({ price: e.target.value })}
          />
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit" disabled={this.state.treatment_id.length<=0}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}





export class MedicalRecord extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      name: 'a',
      patient_id: -1,
      company_id: -1,
      birthday: new Date().toISOString().substring(0, 10),
      gender: -1,
      age: computeAge(new Date().toISOString().substring(0, 10)),
      cpf: '',
      address: '',
      cep: '',
      city: '',
      state: '',
      mobile: '',
      mobile2: '', 
      email: '',
      maritalstatus: -1,
      profession: '',
      idt_front_file: -1,
      idt_back_file: -1,
      allow_contact: true,
      nodata: true,
      emergencyname: '',
      emergencyphone: '',
      health_insurance: '',
      card: '',
      doctor: '',
      doctor_phone: '',
      hospital: '',
      legalname: '',
      legalmaritalstatus: -1,
      legalprofession: '',
      legalcpf: '',
      legalcity: '',
      legalstate: '',
      procedures: [], 
    }; 
  }
   
  
  componentDidMount() {
    this.updatePatientData();
    this.updateProcedureData();
  }


  updatePatientData = () => {
    //http://10.18.166.55:9000/medicalrecord?r=17
    const searchParams = new URLSearchParams(document.location.search)
    var patient_id = searchParams.get('r');    
   
    this.setState({ loading: true });
    this.props.api
      .get('/MedicalRecordPatient/' + patient_id)
      .then((r) => {
        if(r.patient){
          var birthday = new Date(r.patient.birthday);
          this.setState({
            loading: false,            
            name: r.patient.name,
            patient_id: r.patient.id,
            company_id: r.patient.company_id,
            birthday: birthday.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' }).substring(0, 10),
            gender: r.patient.gender,
            age: computeAge(birthday.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' }).substring(0, 10)),
            cpf: r.patient.cpf,
            address: r.patient.address,
            cep: r.patient.cep,
            city: r.patient.city,
            state: r.patient.state,
            mobile: r.patient.mobile,
            mobile2: r.patient.mobile2, 
            email: r.patient.email,
            maritalstatus: r.patient.maritalstatus,
            profession: r.patient.profession,
            idt_front_file: r.patient.idt_front_file,
            idt_back_file: r.patient.idt_back_file,
            allow_contact: r.patient.allow_contact,  
            nodata: false,
            emergencyname: r.patient.emergencyname,
            emergencyphone: r.patient.emergencyphone,
            health_insurance: r.patient.health_insurance,
            card: r.patient.card,
            doctor: r.patient.doctor,
            doctor_phone: r.patient.doctor_phone,
            hospital: r.patient.hospital,
            legalname: r.patient.legalname,
            legalmaritalstatus: r.patient.legalmaritalstatus,
            legalprofession: r.patient.legalprofession,
            legalcpf: r.patient.legalcpf,
            legalcity: r.patient.legalcity,
            legalstate:  r.patient.legalstate,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  
  
  updateProcedureData = () => {
    //http://10.18.166.55:9000/medicalrecord?r=17
    const searchParams = new URLSearchParams(document.location.search)
    var patient_id = searchParams.get('r');    
   
    this.setState({ loading: true });
    this.props.api
      .get('/Procedures/' + patient_id)
      .then((r) => {
        if(r.procedures){ 
          for(var row in r.procedures){
            var start = new Date(r.procedures[row]["start"]); 
            var end = r.procedures[row]["finished"] ? new Date(r.procedures[row]["finished"]) : null;           
            r.procedures[row]["start"] = start.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' }).substring(0, 10);
            r.procedures[row]["end"] = end ? end.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' }).substring(0, 10) : '';   
            
            r.procedures[row]["sessions"] = []; 
            
            r.procedures[row]["anamnesis_form_id"] = null;
            r.procedures[row]["evaluation_form_id"] = null;
            for(var i in r.procedures[row]["questionnaires"]){
              if(r.procedures[row]["questionnaires"][i]["type"] === 1) r.procedures[row]["anamnesis_form_id"] = r.procedures[row]["questionnaires"][i]["id"];
              if(r.procedures[row]["questionnaires"][i]["type"] === 2) r.procedures[row]["evaluation_form_id"] = r.procedures[row]["questionnaires"][i]["id"];
            }
            
            var status = 2;
            if(end) status = 3;
            r.procedures[row]["status"] = status;
          }
          this.setState({
            loading: false, 
            procedures: r.procedures,          
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  
  
  handleOpenProcedure = (id) => {
    this.props.api
      .post('/ProcedureReopen/' + id)
      .then(() => {
        this.updateProcedureData();
        this.handleProcedureClick(null,true,id);
      })
      .catch(() => {
      });
  }
  
  handleCloseProcedure = (id) => {
    this.props.api
      .post('/ProcedureClose/' + id)
      .then(() => {
        this.updateProcedureData();
        this.handleProcedureClick(null,true,id);
      })
      .catch(() => {
      });
  }
  
  handleEditProcedure = (id) => {
    var theID = -1
    for(var row in this.state.procedures){
      if(parseInt(this.state.procedures[row].procedure_id) === parseInt(id)){
        theID = row;
        break;
      }
    }  
    
    this.props.dialog(
                      <EditProcedure
                        edit={true}
                        patient_id={this.state.patient_id}
                        patient_age={this.state.age}
                        procedure_id={id}
                        company_id={this.state.company_id}
                        row={this.state.procedures[theID]}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.updateProcedureData();
                        }}
                      />
                    )
  }
  
  handleDeleteProcedure = (id) => { 
    this.props.dialog(
      <HardConfirmDialog
        title="Excluir Procedimento"
        msg="Ao confirmar, o procedimento será excluído e não poderá ser recuperado"
        reg={ "Documentos, Respostas de Questionários, Sessões de Atendimento, Prescrições serão apagados" }
        onCancel={this.props.dialogClose}
        onConfirm={() => {
          this.props.api
          .delete("/Procedure/" + id)
          .then((r) => {
            this.props.alert(r.message);
            this.props.dialogClose();
            this.updateProcedureData();
          })
          .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
        }}
      />
    )                        
  }
    
  
  handleNewSession = (id, planning_background_file_id) => {
    this.props.dialog(
                      <NewSessionDialog
                        patient_id={this.state.patient_id}
                        procedure_id={id}
                        company_id={this.state.company_id}
                        planning_background_file_id={planning_background_file_id}
                        template_image_id={planning_background_file_id}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => { this.props.dialogClose() }}
                        updateProcedureData={() => { this.handleProcedureClick(null,true,id); }}
                      />
                    )
  }
  
  
  handleProcedureClick = (event,expanded,procedure_id) => {
    if(expanded){
      var theID = -1
      for(var row in this.state.procedures){
        if(parseInt(this.state.procedures[row].procedure_id) === parseInt(procedure_id)){
          theID = row;
          break;
        }
      }
      if(theID === -1) return;
        
      this.setState({ loading: true });
      this.props.api
        .get('/MedicalSessions/' + procedure_id)
        .then((r) => {
          var proceduresCopy = this.state.procedures;
          proceduresCopy[theID]["sessions"] = r.sessions; 
          
          this.props.api.get('/DocsFromProc/' + procedure_id).then((s) => {
            proceduresCopy[theID]["documents"] = s.documents;
            
            //Descobre se a sessão já tem documento assinado
            for(var s in proceduresCopy[theID]["sessions"]){
              proceduresCopy[theID]["sessions"][s]["signed"] = false;
              for(var d in proceduresCopy[theID]["documents"]){
                if((proceduresCopy[theID]["sessions"][s].id == proceduresCopy[theID]["documents"][d].session_id) && proceduresCopy[theID]["documents"][d].signed)
                  proceduresCopy[theID]["sessions"][s].signed = true;
              }
            }
            
            this.setState({ 
              loading: false,
              procedures: proceduresCopy,
            });
            
          });                          
                  
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
  } 
  

  handleBatchSignDocument = (procedure_id) => {
    this.props.dialog(
      <SignatureDialog
        title = {"Assinar Documento"}
        batch_sign = {true}
        document_id = {-1}
        session_id = {-1}
        procedure_id = {procedure_id}
        api={this.props.api}
        alert={this.props.alert}
        dialogClose={() => { this.props.dialogClose() }}
        dialogConfirm={(batch_sign, document_id, session_id, file_id, procedure_id) => {this.handleSignatureDialogReturn(batch_sign, document_id, session_id, file_id, procedure_id); }}
      />
    )  
  }
  
    
  handleSignDocument = (procedure_id, document_id, file_id, session_id, type) => {
    this.props.dialog(
      <SignatureDialog
        title = {"Assinar Documento"}
        batch_sign = {false}
        document_id = {document_id}
        session_id = {session_id}
        procedure_id = {procedure_id}
        api={this.props.api}
        alert={this.props.alert}
        dialogClose={() => { this.props.dialogClose() }}
        dialogConfirm={(batch_sign, document_id, session_id, file_id, procedure_id) => {this.handleSignatureDialogReturn(batch_sign, document_id, session_id, file_id, procedure_id); }}
      />
    )  
  }
  
  handleSignatureDialogReturn = (batch_sign, document_id, session_id, file_id, procedure_id) => {
    if(!batch_sign){
      this.props.api
          .get('/DocsSign/' + document_id + '/' + session_id + '/' + file_id + '/' + true)
          .then((r) => {
            this.props.alert(r.message);
          
            this.handleProcedureClick(null,true,procedure_id)
          })
          .catch(() => this.props.alert('Ocorreu um erro ao assinar o arquivo')); 
    }
    else{
      for(var i in this.state.procedures){
        if(this.state.procedures[i].procedure_id == procedure_id){
          //Captura quais documentos precisam ser assinados
          var documentsToSign = [];
          for(var j in this.state.procedures[i].documents){
            if(!this.state.procedures[i].documents[j].signed){
              documentsToSign.push(this.state.procedures[i].documents[j]);
            }
          } 
          //Assina os documentos
          var async_requests = [], last_request = "";
          for(var j in documentsToSign){
            console.log(j);
            if(j == (documentsToSign.length-1)){ 
              //É o último documento a ser assinado, avisar que o arquivo de assinaturas pode ser descartado
              last_request = '/DocsSign/' + documentsToSign[j].id + '/' + documentsToSign[j].session_id + '/' + file_id + '/' + true;
            }
            else{
              //Não é o último documento a ser assinado, mantenha o arquivo de assinaturas
              async_requests.push( this.props.api.get('/DocsSign/' + documentsToSign[j].id + '/' + documentsToSign[j].session_id + '/' + file_id + '/' + false) );
            }
          }
          //Dispara as requisições
          Promise.all(async_requests)
                 .then(values => {
                   console.log(values); 
                   this.props.api
                             .get(last_request)
                             .then((r) => {
                               this.props.alert(r.message);
          
                               this.handleProcedureClick(null,true,procedure_id)
                             })
                             .catch(() => this.props.alert('Ocorreu um erro ao assinar o arquivo'));                     
                 })
                 .catch(error => {
                   this.props.alert('Ocorreu um erro ao assinar os arquivos. ' + error);
                 });
          
          
          
          
          
          
          
          break; //do 1o for
        }
      }
    }
  }
  
  
  handleViewDocument = (procedure_id, document_id, file_id, session_id, type) => {    
    this.props.api
      .get('/DocView/' + document_id + '/' + session_id, { responseType: 'blob'})
      .then((r) => {
        if( r.type !== "application/json" ){  
          const url = URL.createObjectURL(r);   
          // in case you don't need the blob anymore, blob can be garbage collected
          //img.onload = e => URL.revokeObjectURL(url);
          
          window.open(url);
        }
        else{
          try{  
          const outurl = URL.createObjectURL(r);
          fetch(outurl).then(res => {
            res.text().then(txt => {
              var dic = JSON.parse(txt);
              var msg = dic.msg
              this.props.alert(msg);
            });  
          });
          }catch(err){
            console.log(err);
          }
        }
      })
      .catch(() => this.props.alert('Ocorreu um erro ao visualizar o arquivo.'));
  }
  
  
  handleMakeSurvey= (procedure_id, questionnaire_id, document_type) => {
    if(!questionnaire_id){
      this.props.alert("Não existe " + C.DocumentType[document_type] + " associada a este tratamento.");
      return;
    }
    
    this.props.dialog(
                      <Survey
                        patient_id={this.state.patient_id}
                        procedure_id={procedure_id}
                        questionnaire_id={questionnaire_id}
                        company_id={this.state.company_id}
                        document_type={document_type}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.updateProcedureData();
                          this.handleProcedureClick(null,true,procedure_id);
                        }}
                      />
                    )
  }
  
  
  render() {
    return (
       <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <Paper style={{padding: '1rem', minWidth: '100%', marginBottom: '1rem'}}>
            <Stack direction="row" spacing={3} >
              <Typography gutterBottom color="primary"><strong>{this.state.name}</strong></Typography>
              <D size="0.5rem" />
              
              <Tooltip title="Informações Cadastrais" arrow style={{padding: '0rem', margin: '0rem'}}>
                <IconButton onClick={() => 
                  this.props.dialog(
                          <ViewPatient
                            edit
                            row={this.state}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                            }}
                            user={this.props.user}
                          />
                  )}>
                  <Visibility />
                </IconButton>
              </Tooltip>
                          
            </Stack>
            <Typography gutterBottom >{computeAge(this.state.birthday)} anos - {this.state.profession}</Typography>
          </Paper>
        </D>
        <D size="1rem" />
         
        <D className="row w aF">  
          <Paper style={{padding: '1rem', minWidth: '100%'}}>
            <D className="col w aF">  
              <Stack direction="row" spacing={3} >
                <Typography gutterBottom color="primary"><strong>Procedimentos</strong></Typography>
                <D size="0.5rem" />
              
                {this.props.permission === 'w' && (
                <Tooltip title="Adicionar Procedimento" arrow style={{padding: '0rem', margin: '0rem'}}>
                  <IconButton onClick={() => 
                    this.props.dialog(
                      <EditProcedure
                        edit={false}
                        patient_id={this.state.patient_id}
                        patient_age={this.state.age}
                        company_id={this.state.company_id}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.updateProcedureData();
                        }}
                      />
                    )
                  }>
                    <CreateNewFolder />
                  </IconButton>
                </Tooltip>   
                )}                       
              </Stack>
              
              <D size="1rem" />        
 
              {
                this.state.procedures.length === 0 ? <Typography gutterBottom>Não há procedimento</Typography> :
                  this.state.procedures.map( item => {
                    var unsignedDocs = [];
                    var hasAnamnesis = false;
                    
                    for(var i in item.documents){
                      if(!item.documents[i].signed)
                        unsignedDocs.push(C.DocumentType[ item.documents[i].type ]);
                      if(item.documents[i].type === 1)
                        hasAnamnesis = true;
                    }
                    
                    return(
                      <Accordion key={"procedure"+item.procedure_id} onChange={ (event,expanded) => this.handleProcedureClick(event,expanded,item.procedure_id)} disableGutters >           
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ flexGrow: 1 }} >
                          {((unsignedDocs.length > 0) || (!hasAnamnesis) || (item.status===1)) ? <Cancel fontSize="small" sx={{ color: 'red' }} /> : <></> }
                          {((unsignedDocs.length === 0) && (hasAnamnesis) && (item.status===2)) ? <CheckCircle fontSize="small" sx={{ color: 'green' }} /> : <></> }
                          {((unsignedDocs.length === 0) && (hasAnamnesis) && (item.status===3)) ? <RemoveCircle fontSize="small" sx={{ color: 'grey' }} /> : <></> }
                          <D size="0.5rem" />
                          <Typography><strong>{item.treatmentname}</strong> - Início: {item.start}, Fim: {item.end==="" ? "- - -" : item.end}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography variant="overline" color='grey'>{item.training_patient ? "Paciente Modelo   -   " : ""}Consentimento: {C.AllowedToPostType[item.allowed_to_post]}{item.allowed_to_post_complement ? (", "+item.allowed_to_post_complement) : ""}{ " (ID " + item.procedure_id + ")"}</Typography>    

                          <D className="wrp aC">
                          { 
                            item.sessions.map( s => {
                              return(
                                <Session
                                  key={s.id}
                                  data={s}
                                  patient_id={this.state.patient_id}
                                  template_image_id={item.planning_background_file_id}
                                  prescription_id={item.prescription_id}
                                  api={this.props.api}
                                  alert={this.props.alert}
                                  dialog={this.props.dialog}
                                  handleProcedureUpdate={() => {
                                    this.handleProcedureClick(null,true,item.procedure_id);
                                  }}
                                  dialogClose={() => {
                                    this.props.dialogClose();
                                  }}
                                />
                              );
                            })
                          } 
                          </D>
                          


                          <List sx={{ width: '100%', bgcolor: 'whitesmoke' }} dense={true} 
                            subheader={ (hasAnamnesis) ?
                                             (<ListSubheader component="div" id="nested-list-subheader" sx={{ bgcolor: 'whitesmoke', fontSize: '1rem' }}>
                                               <strong>Documentação</strong>
                                             </ListSubheader>)
                                             :
                                             (<ListSubheader component="div" id="nested-list-subheader" sx={{ color: 'red', bgcolor: '#ffe7e7', fontSize: '1rem' }}>
                                               <strong>Documentação - Falta Anamnese</strong>
                                             </ListSubheader>)
                            }>
                            <Divider />      
                            {
                              item.documents.map( doc => {
                                return(
                                  <ListItem key={'d'+doc.id} divider>
                                    <ListItemText primary={C.DocumentType[ doc.type ]} secondary={(new Date(doc.created_at)).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' }).split(',')[0] } />
                                    <ListItemSecondaryAction>
                                      { !doc.signed &&
                                      <Tooltip title="Assinar" arrow>
                                        <IconButton onClick={() => this.handleSignDocument(item.procedure_id, doc.id, doc.file_id, doc.session_id, doc.type)} ><DrawIcon sx={{ color: 'red' }} /></IconButton>
                                      </Tooltip>
                                      }
                                      <Tooltip title="Visualizar" arrow>
                                        <IconButton onClick={() => this.handleViewDocument(item.procedure_id, doc.id, doc.file_id, doc.session_id, doc.type)} ><Visibility /></IconButton>
                                      </Tooltip>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                )
                              })
                            }     
                          </List>              
                          
                        
                        </AccordionDetails>
                        <AccordionActions disableSpacing> 
                           {(item.finished==null) && <>
                            <Tooltip title="Nova Sessão" arrow >
                            <IconButton procedure_id={item.procedure_id} planning_background_file_id={item.planning_background_file_id} onClick={(e) => this.handleNewSession(e.currentTarget.getAttribute('procedure_id'),e.currentTarget.getAttribute('planning_background_file_id'))}><PermContactCalendar /></IconButton>
                            </Tooltip>
                          </>
                          }
                        
                          <Tooltip title="Anamnese" arrow >
                          <IconButton procedure_id={item.procedure_id} questionnaire_id={item.anamnesis_form_id} onClick={(e) => this.handleMakeSurvey(e.currentTarget.getAttribute('procedure_id'),e.currentTarget.getAttribute('questionnaire_id'),1)}>
                          {
                            hasAnamnesis ? (<HealthAndSafety />) : (<HealthAndSafety sx={{ color: 'red' }}/>)
                          }</IconButton>
                          </Tooltip>
                          
                          <Tooltip title="Ficha de Avaliação" arrow >
                          <IconButton procedure_id={item.procedure_id} questionnaire_id={item.evaluation_form_id} onClick={(e) => this.handleMakeSurvey(e.currentTarget.getAttribute('procedure_id'),e.currentTarget.getAttribute('questionnaire_id'),2)}><Architecture /></IconButton>
                          </Tooltip>
                          
                          <Divider orientation="vertical" flexItem />
                          
                          <Tooltip title="Compartilhar" arrow >
                          <IconButton onClick={() => console.log("Compartilhar")}><Share /></IconButton>
                          </Tooltip>
                          
                          {(unsignedDocs.length > 0) && <>
                            <Tooltip title="Assinar em Bloco" arrow >
                            <IconButton onClick={() => this.handleBatchSignDocument(item.procedure_id)}><AppRegistration /></IconButton>
                            </Tooltip>
                          </>}
                          
                          <Divider orientation="vertical" flexItem />
                                               
                          {(item.finished!=null) && <>
                            <Tooltip title="Reabrir Procedimento" arrow>
                            <IconButton procedure_id={item.procedure_id} onClick={(e) => this.handleOpenProcedure(e.currentTarget.getAttribute('procedure_id'))}><FolderOpen /></IconButton>
                            </Tooltip>
                          </>}
                        
                          {(item.finished==null) && <>
                            <Tooltip title="Finalizar Procedimento" arrow>
                            <IconButton procedure_id={item.procedure_id} onClick={(e) => this.handleCloseProcedure(e.currentTarget.getAttribute('procedure_id'))}><FolderOff /></IconButton>
                            </Tooltip>
                          </>
                          }
                        
                          <Tooltip title="Editar Procedimento" arrow>
                          <IconButton procedure_id={item.procedure_id} onClick={(e) => this.handleEditProcedure(e.currentTarget.getAttribute('procedure_id'))}><Edit /></IconButton>
                          </Tooltip>
                        
                          <Tooltip title="Apagar Procedimento" arrow >
                          <IconButton procedure_id={item.procedure_id} onClick={(e) => this.handleDeleteProcedure(e.currentTarget.getAttribute('procedure_id'))}><Delete /></IconButton>
                          </Tooltip>                                              
                        </AccordionActions>
                      </Accordion>
                    )                
                  })
              }

            
            
            
            

            
            
            
            
            
            
            
            
            
            
            
            
            </D>  
          </Paper> 
        </D>
        
        
        
      </D>
      
      
    );
  }
}
